module.exports = __webpack_public_path__ + "fonts/KaTeX_Script-Regular.1b3161eb.woff2";